
import {
  Swiper,
  SwiperSlide
} from "vue-awesome-swiper";
import ProductCard from "~/cms/blocks/components/OurTransportOperationalTransportBlock/ProductCard";
import "swiper/css/swiper.css";

export default {

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoHeight: true
      },

      activeSlide: 0
    }
  },

  props: {
    products: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    productsList: function () {
      let list = [];
      let section = [];
      this.products.map(t => {
        section.push(t);
        if (section.length > 1) {
          list.push(section);
          section = [];
        }
      });
      if (section.length > 0) {
        list.push(section)
      };
      return list
    }
  },

  components: {
    Swiper,
    SwiperSlide,

    ProductCard
  },

  methods: {
    slideChange: function () {
      const activeIndex = this.$refs?.refSwiper?.$swiper?.activeIndex;
      this.activeSlide = activeIndex;
    },
    slidePrev: function () {
      this.$refs?.refSwiper?.$swiper.slidePrev();
    },
    slideNext: function () {
      this.$refs?.refSwiper?.$swiper.slideNext();
    },
  }
}
